import { useState } from 'react'
import clsx from 'clsx'

import { formatSkillLabel } from 'utils/skill.util'

import { IExpandableSkillsProps } from './types'

const ExpandableSkills = ({
  skills,
  addSkill,
  isPure,
  size = 'default',
  isExpand = false,
  isPrint = true,
  classNameItem,
  divider
}: IExpandableSkillsProps) => {
  const [expanded, setExpanded] = useState(isExpand)

  return (
    <div
      key="active"
      className={clsx(
        'flex flex-wrap gap-x-2 gap-y-2',
        !isPure && 'mt-2 pb-10',
        size === 'small' ? 'text-sm' : '',
        isPrint && 'print:hidden'
      )}
    >
      {skills.slice(0, 3).map((skill, index) => {
        return (
          <span
            key={index}
            className={clsx(
              'rounded-full border border-gray-300',
              size === 'small' ? 'py-1 px-2 text-sm' : 'px-4 py-2',
              classNameItem
            )}
          >
            {formatSkillLabel(skill.value, skill.years)} {divider}
          </span>
        )
      })}
      {skills.length > 3 && !expanded && (
        <span
          className={clsx(
            'cursor-pointer rounded-full  border border-gray-300  hover:bg-gray-50 ',
            size === 'small' ? 'px-2 py-1 text-sm' : 'px-4 py-2',
            classNameItem
          )}
          onClick={() => setExpanded(true)}
        >
          {skills.length - 3}+
        </span>
      )}
      {skills.length > 3 &&
        expanded &&
        skills.slice(3).map((skill, index) => {
          return (
            <span
              key={index}
              className={clsx(
                'fade-in cursor-pointer rounded-full border border-gray-200 align-middle',
                size === 'small' ? 'px-2 py-1 text-sm' : 'px-4 py-2',
                classNameItem
              )}
              onClick={() => setExpanded(false)}
            >
              {formatSkillLabel(skill.value, skill.years)} {divider}
            </span>
          )
        })}
      {addSkill && (
        <span
          className={clsx(
            'rounded-full border border-gray-300 ',
            size === 'small' ? 'px-2 py-1 text-sm' : 'px-4 py-2',
            isPrint && 'print:hidden',
            classNameItem
          )}
        >
          {addSkill}
        </span>
      )}
    </div>
  )
}

export default ExpandableSkills
